var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaScheduledMessages = function SvgPaScheduledMessages(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35333C",
    fillRule: "nonzero",
    d: "M14.208 5c.275 0 .459.184.459.46v.458h1.813c.78 0 1.377.597 1.377 1.378l.001 5.859c1.26.551 2.142 1.81 2.142 3.274C20 18.4 18.401 20 16.429 20c-1.465 0-2.723-.881-3.274-2.142H6.378C5.597 17.857 5 17.26 5 16.48V7.296c0-.78.597-1.378 1.378-1.378H8.19V5.46c0-.275.184-.459.46-.459.275 0 .458.184.458.46v.458h4.64V5.46c0-.275.184-.459.46-.459zm2.21 8.657c-.21 0-.382.11-.382.245v2.704c0 .038.013.074.037.106.011.19.097.339.2.339h2.239c.111 0 .202-.172.202-.383 0-.21-.09-.382-.202-.382l-1.711-.001v-2.383c0-.118-.132-.217-.306-.24zm.52-4.065H5.919v6.888c0 .275.184.459.46.459h6.515c-.024-.167-.036-.337-.036-.51 0-1.973 1.6-3.572 3.572-3.572.173 0 .343.012.51.036V9.592zM8.19 6.837H6.378c-.276 0-.46.183-.46.459v1.377h11.02V7.296c0-.276-.183-.46-.458-.46h-1.813v.46c0 .275-.184.46-.46.46-.275 0-.458-.185-.458-.46v-.46h-4.64v.46c0 .275-.184.46-.46.46-.275 0-.459-.185-.459-.46v-.46z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaScheduledMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pa-scheduled-messages.97abf8b7c25a7965a1fc2805af5cc310.svg";